module.exports = __webpack_public_path__ + "media/images/mission-e805f9e0cfe63897ba14c14da6e254a8.jpg";